






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class VueError extends Vue {
  
  @Prop({ default: '',  type: String}) label!: string;

}
